import React from 'react'
import clsx from 'clsx'
import { useHistory } from 'react-router-dom'
import { createStyles, Theme, makeStyles } from '@material-ui/core/styles'
import { Card, CardHeader, CardContent, CardActions } from '@material-ui/core'
import Grid from '@material-ui/core/Grid'
import M_ButtonSearch from 'components/1_Atoms/2_Molecules/M_ButtonSearch'
import M_FieldTextLong from 'components/1_Atoms/2_Molecules/M_FieldTextLong'
import A_Message from 'components/1_Atoms/A_Message'
import { useChangePassword } from 'hooks/useLogin'
import O_License from '../O_License'
import A_FieldCheckBox from 'components/1_Atoms/A_FieldCheckBox'
import { useMediaQueryContext } from 'MediaQueryProvider'

const WIDTH = 760
const WIDTH_MIN = 320
const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      flexGrow: 1,
      alignContent: 'center',
      alignItems: 'center',
    },
    container: {
      display: 'flex',
      flexWrap: 'wrap',
      margin: `${theme.spacing(0)} auto`,
    },
    header: {
      textAlign: 'center',
      background: '#212121',
      color: '#fff',
    },
    card: {
      width: WIDTH,
      marginTop: theme.spacing(10),
      marginBotton: theme.spacing(10),
    },
    cardM: {
      width: WIDTH_MIN,
      marginTop: theme.spacing(10),
      marginBotton: theme.spacing(10),
    },
  }),
)

const O_SearchBoxChangePassword = ({ title }: { title: string }) => {
  const classes = useStyles()
  const { isMobileSite } = useMediaQueryContext()
  const history = useHistory()
  const [
    name,
    changeName, // 氏名変更
    pass,
    changePass, // パスワード変更
    rePass,
    changeRePass, // 再入力パスワード変更
    changed, // 変更判定
    click, // ボタン押下処理
    message,
    messageColor, // メッセージ
    clickAdd, // ユーザー追加リンク押下処理
    disabled, // ボタン活性判定
    isKariLogin, // 仮ログイン判定
    licenseCheck, // ライセンス同意チェック
    changeLicenseCheck, // ライセンス同意チェック変更処理
  ] = useChangePassword(history)

  return (
    <form className={classes.container} autoComplete="new-off">
      <Card className={clsx(classes.card, isMobileSite && classes.cardM)} onSubmit={click}>
        <CardHeader className={classes.header} title={title} autoComplete="new-off" />
        <CardContent>
          {changed ? null : (
            <div>
              <M_FieldTextLong
                key={1} //
                tab={1}
                label="氏名"
                labelWidth={1}
                max={25}
                valueCode={name}
                change={changeName}
                autoComplete="new-password"
              />
              <M_FieldTextLong
                key={2} //
                tab={2}
                type="password"
                label="新パスワード"
                labelWidth={1}
                max={25}
                valueCode={pass}
                change={changePass}
                autoComplete="new-password"
              />
              <M_FieldTextLong
                key={3} //
                tab={3}
                type="password"
                label="再入力新パスワード"
                labelWidth={1}
                max={25}
                valueCode={rePass}
                change={changeRePass}
              />
              <A_Message color="red" message="半角英数字8文字以上、20文字以内でご入力ください" align="center" />
            </div>
          )}
        </CardContent>
        <CardActions>
          <Grid container className={classes.root} justifyContent="center">
            {isKariLogin ? ( // 仮ログイン時は使用許諾を表示
              <>
                <Grid item xs={12}>
                  <O_License />
                </Grid>
                <A_FieldCheckBox label="使用承諾に同意する" check={licenseCheck} change={changeLicenseCheck} position="end" />
                <Grid item xs={10}></Grid>
              </>
            ) : (
              <></>
            )}
            <Grid item xs={8}>
              <A_Message color={messageColor} message={message ? message : ''} align="center" />
            </Grid>
            <Grid item xs={8}>
              <M_ButtonSearch label={changed ? '戻る' : '登録'} onClick={click} disabled={disabled} />
              {isKariLogin || changed ? ( // 本ログイン時はユーザー追加リンクを表示
                <></>
              ) : (
                <A_Message message="ユーザー追加はこちら" link={true} align="center" onClick={clickAdd} />
              )}
            </Grid>
          </Grid>
        </CardActions>
      </Card>
    </form>
  )
}
export default React.memo(O_SearchBoxChangePassword)
